import { Box, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../shared/components/buttons/StandardButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

type IdCardSignupStepHeaderProps = Readonly<{
    step: number
    handleBack: () => void
}>

const useStyles = makeStyles()(() => ({
    backButton: {
        color: "black",
        padding: "0 !important",
    },
}))

export const CompleteRegistrationHeader = () => {
    return (
        <Stack gap="1rem">
            <LocalizedStrict id="id-card-signup-title">
                <Typography variant="h4" fontWeight={600}>
                    Complete registration
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="id-card-signup-description">
                <Typography variant="body1">
                    Please complete the registration process. Once you have registered your ID card, you can use it to
                    purchase food in the canteen by simply scanning it at the POS screen.
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}

export const IdCardSignupStepHeader = ({ step, handleBack }: IdCardSignupStepHeaderProps) => {
    const { classes } = useStyles()
    switch (step) {
        case 0:
            return <CompleteRegistrationHeader />
        case 1:
            return (
                <>
                    <Stack justifyContent="start">
                        <Box>
                            <LocalizedStrict id="create-order-tabs-error-dialog-close-button">
                                <StandardButton
                                    className={classes.backButton}
                                    startIcon={<FontAwesomeIcon size="xs" icon={faChevronLeft} />}
                                    fullWidth={false}
                                    variant="text"
                                    color="black"
                                    onClick={handleBack}
                                >
                                    Go Back
                                </StandardButton>
                            </LocalizedStrict>
                        </Box>
                    </Stack>
                    <LocalizedStrict id="id-card-signup-subscription">
                        <Typography variant="h4" fontWeight={600}>
                            Select subscription
                        </Typography>
                    </LocalizedStrict>
                </>
            )
        default:
            return <></>
    }
}
